import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfigService } from '@web-client/shared';

@Component({
  selector: 'lib-footer',
  standalone: true,
  imports: [RouterModule],
  template: `
      <footer class="mt-auto py-6 border-t" style="border-color: var(--mat-sys-outline-variant); background-color: var(--mat-sys-surface-container-low)">
        <div class="max-w-7xl mx-auto px-6">
          <div class="flex flex-col md:flex-row justify-between items-center gap-4">
            <div class="flex items-center gap-4 text-sm font-medium" style="color: var(--mat-sys-on-surface-variant)">
              <span>&copy; {{ currentYear }} ToolCade</span>
              <span class="hidden md:inline opacity-30">|</span>
              <nav class="flex gap-4">
                <a routerLink="/terms-of-service" class="hover:text-primary transition-colors" style="color: inherit">Terms</a>
                <a routerLink="/privacy-policy" class="hover:text-primary transition-colors" style="color: inherit">Privacy</a>
                <a routerLink="/disclaimer" class="hover:text-primary transition-colors" style="color: inherit">Disclaimer</a>
              </nav>
            </div>
            
            <div class="text-xs uppercase tracking-widest font-semibold opacity-50 flex items-center gap-2" style="color: var(--mat-sys-on-surface)">
              <span>Built for Performance & Privacy</span>
              <span class="opacity-30">|</span>
              <span class="lowercase opacity-80">v{{ version }}</span>
            </div>
          </div>
        </div>
      </footer>`
})
export class FooterComponent {
  private configService = inject(ConfigService);
  // A property to hold the current year for the template
  currentYear: number = new Date().getFullYear();

  get version(): string {
    return this.configService.version;
  }
}